export default "__VITE_ASSET__ZDiacuCb__"